import { render, staticRenderFns } from "./VehiclesTable.vue?vue&type=template&id=54da9472&scoped=true&"
import script from "./VehiclesTable.vue?vue&type=script&lang=js&"
export * from "./VehiclesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da9472",
  null
  
)

export default component.exports